const UNIQUE_KEY_IDENTIFIER_REGEX = /^unique_key_\d{3}$/;

export const getFormFieldKey = (key: string) => {
  if (key.split(';').length > 1) {
    const keyParts = key.split(';');
    if (UNIQUE_KEY_IDENTIFIER_REGEX.exec(keyParts.at(-1)!)) {
      keyParts.pop();
      return keyParts.join(';');
    }
  }
  return key;
};
